import React from "react";
import EmailWeb from "./EmailWeb";

const EmailViewer = () => {
  const getDecodedData = () => {
    const query = new URLSearchParams(window.location.search);
    const encodedData = query.get("");
    if (!encodedData) return null;

    try {
      const decodedData = JSON.parse(atob(encodedData));
      return decodedData;
    } catch (error) {
      console.error("Failed to decode URL data:", error);
      return null;
    }
  };

  const data = getDecodedData();

  if (!data) {
    return <p>Error: Invalid or missing data in the URL.</p>;
  }

  const { company, name, title } = data;

  return (
    <EmailWeb company={company} name={name} title={title} />
  );
};

export default EmailViewer;